export default {
  reports: {
    usersByStatus: "Utenti per Stato",
    usersByGender: "Utenti da Genere",
    gen: "Genere",
    gender: "Grafico di genere",
    male: "Maschio",
    female: "Femmina",
    other: "Altri",
    unspefied: "Non specificato",
    byCountry: "Per Paese",
    avgPriceFarmer: "Prezzo di vendita medio da tutti gli agricoltori",
    avgPrice: "Prezzo medio di vendita per agricoltore",
    selectYear: "Seleziona anno",
    total: "Totale",
    farmerName: "Nome del coltivatore",
    farmerProdChart: "Produzione agricola Grafico",
    production: "Produzione",
    byProduction: "Per la produzione",
    byName: "Per nome",
    descending: "Discussione",
    ascending: "Finanziamenti",
    buyingStationProdChart: "Grafico di produzione della stazione",
    buyingStation: "Comprare la stazione",
    buyingStationName: "Nome della stazione di acquisto",
    dryMilling: "Mulino a secco",
    dryMillingName: "Nome della fresatura a secco",
    dryMillingProdChart: "Grafico di produzione di fresatura a secco",
    view: "Vista",
    date: "Data",
    reports: "Relazioni",
    today: "Oggi",
    week: "Rassegna",
    month: "Mese",
    year: "Anno",
    all: "Tutti",
    selectCrop: "Seleziona il raccolto",
    selectRegion: "Seleziona la Regione",
    selectProvinceState: "Seleziona Provincia/Stato",
    downloadPdfReport: "Scarica PDF Relazione",
    export: "Esportazione",
    search: "Ricerca",
    yield: "Rendimento",
    avgAreaPerUnit: "Area Avg in {unità}",
    yieldPerUnit: "Rendimento/unità",
    averageSellingPriceByAllFarmers:
      "Prezzo di vendita medio da tutti gli agricoltori",
    averageSellingPricePerFarmer: "Prezzo medio di vendita per agricoltore",
    pricePaid: "Prezzo pagato",
    pests: {
      pestReport: "Relazione Pest",
      filterByCrops: "Filtra per Crops",
      pestStatistics: "Statistiche del Pest",
      regions: "Regioni",
      occurrences: "Occurrence",
      pestChart: "Grafico dei parassiti",
      totalArea: "Superficie totale",
      pestName: "Nome della lista",
      region: "Regione",
      crop: "Croci",
      listByLand: "Elenco per Land",
    },
    regions: {
      regionalReport: "Relazione regionale",
      listByFarm: "Elenco delle aziende agricole",
      listByFarmers: "Elenco degli agricoltori",
      listByYield: "Elenco di Yield",
      regionalStatistics: "Statistiche regionali",
      countries: "Paesi",
      states: "Stati/Provincia",
      city: "Città/Town/Village",
      farmsIn: "Agriturismi in Puglia",
      regionalChart: "Grafico regionale",
      farms: "Aziende agricole",
      regionName: "Nome della Regione",
      farmers: "Agricoltori",
      yield: "Rendimento/Acre",
    },
    dashboard: {
      topCharts: "Grafico superiore",
      regions: "Regioni",
      noOfFarms: "Numero di aziende agricole/regione",
      provinces: "Stati membri",
      landArea: "LandArea",
      avgFarmerLand: "Avg. Terreno agricolo",
      viewAll: "Vedi tutto",
      crops: "Croci",
      plantedAreaCrop: "Area vegetale/Croppo",
      plantedArea: "Area vegetale",
      avgYieldCrop: "Avg. Rendimento/Crop",
      averageYield: "Rendimento medio",
      yieldChart: "Grafico di rendimento",
      selectFarm: "Seleziona Agriturismo",
      soilQuality: "Qualità del suolo",
      pests: "Pests",
      occurrences: "eventi",
      equipments: "Attrezzature",
      goalAchievedChart: "Obiettivi raggiunti Grafico",
      soilValues: "Valori del suolo",
      soil: "Soil",
      showReport: "Mostra i rapporti su Dashboard",
      selectAll: "Seleziona tutto",
    },
    weight: "Peso",
    quality: "Qualità",
    price: "Prezzo",
  },
};
